import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import { AnswerKeyItem } from '../entities/AnswerKey'
import type { Assessment } from '../entities/Assessment'

@InputType()
export class SaveAnswerKeyArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => [AnswerKeyItem])
  items: AnswerKeyItem[]
}

export interface ISaveAnswerKey extends IAction<Assessment, SaveAnswerKeyArgs> {}
